<template>
  <v-btn color="primary" @click="$emit('click')" :disabled="disabled">
    <v-icon>mdi-download</v-icon>Save
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  name: "save-btn",
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/SaveButton.vue